// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Mixins
import {EventBus} from '../event_bus/EventBus'

@Component
export class FormInput extends mixins(EventBus) {

    public isFormTourCurrentStep: boolean = false

    @Watch('isFormTourCurrentStep')
    public watchIsFormTourCurrentStep(isFormTourCurrentStep) {
        this.dispatch('InputGroup', 'isFormTourCurrentStep', [isFormTourCurrentStep])
    }
    
    public created() {
        
    }
    
    public destroyed() {
        
    }
}